import {FormField, FormFieldType, SelectionOption} from 'lionheartland';

export class PutConstraintFormFields {

    public name: FormField
    public identifier: FormField
    public description: FormField

    constructor() {

        this.name = new FormField(
          'name',
          'Name',
          null,
          FormFieldType.text,
          false,
        )
        this.identifier = new FormField(
          'identifier',
          'Identifier',
          null,
          FormFieldType.text,
          false,
        )
        this.description = new FormField(
          'description',
          'Description',
          null,
          FormFieldType.text,
          false,
          true,
          ""
        )

    }
}

const fields = new PutConstraintFormFields()

export const putConstraintFormFieldOptions: {[key: string]: FormField} = {
  name: fields.name,
  identifier: fields.identifier,
  description: fields.description,
};